import PropTypes from 'prop-types';
import { getUnitOptions } from '@/utils/unitUtils';
import Select from './Select';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { isDefined } from '@/utils/miscUtils';

const ConversionBase = ({
  name,
  value,
  units,
  isDefault,
  className = 'join-item w-1/4 border-l-0',
  disabled = false,
  readOnly = false,
  onChange,
}) => {
  const options = getUnitOptions(units);
  const { register, setValue } = useFormContext();

  useEffect(() => {
    if (isDefined(value)) {
      setValue(name, value, { shouldValidate: true, shouldDirty: false });
    }
  }, [value, name, setValue]);

  if (options.length === 1 || disabled || readOnly) {
    const matchingOption = options.find(option => option.value === value) || options[0];

    return (
      <>
        <input {...register(name)} type="hidden" name={name} />
        <div
          className={`input ${className.match('w-') ? '' : 'w-fit'} input-sm ${className} ${disabled || readOnly ? 'input-disabled' : 'input-bordered'}`}
        >
          {matchingOption.label}
        </div>
      </>
    );
  }

  return (
    <Select
      name={name}
      onChange={onChange}
      options={options}
      className={`select-sm ${className.match('w-') ? '' : 'w-fit'} ${className} ${!isDefault ? 'font-bold' : ''}`}
    />
  );
};

ConversionBase.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isDefault: PropTypes.bool,
  units: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ConversionBase;
